var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"arrow\"><path fill-rule=\"evenodd\" d=\"M18.51 29.489h2.337V0H18.51zm1.228 8.409L0 13.373v3.853L18.336 40h2.686l18.335-22.89v-3.737z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol